export default {
    methods: {
        getInvoicesShutter(props) {
            return {
                'invoice-list': {
                    name: 'invoice-list',
                    title: this.$t('horse.factures'),
                    cmpPath: 'components/Invoice/List',
                    noClass: true
                },
                'invoice-unpaid': {
                    name: 'invoice-unpaid',
                    title: this.$t('invoice.titre_impayes'),
                    cmpPath: 'components/Invoice/Impayes',
                    noClass: true
                },
                'invoice-trackings': {
                    name: 'invoice-trackings',
                    title: this.$t('global.tracking_emails'),
                    cmpPath: 'components/Trackings',
                    props  
                }
            }
        },

        setupInvoiceList() {
            const shutters = this.getInvoicesShutter({})
            this.shutterPanel().open(shutters['invoice-list'])
        },

        setupInvoiceUnpaidList() {
            const shutters = this.getInvoicesShutter({})
            this.shutterPanel().open(shutters['invoice-unpaid'])
        },

        async openTrackingsShutter(invoice_id) {
            const shutters = this.getInvoicesShutter({ invoice_id })
            this.shutterPanel().open(shutters['invoice-trackings'])
        }
    }
}